import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ngfModule } from 'angular-file';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { DocumentRoutingModule } from './document-routing.module';
import { CoreModule } from '../../core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentIssueComponent } from './document-issue/document-issue.component';
import { DocumentIssueFormComponent } from './document-issue/components/document-issue-form/document-issue-form.component';
import { SellerFormComponent } from './document-issue/components/seller-form/seller-form.component';
import { DocumentFormComponent } from './document-issue/components/document-form/document-form.component';
import { BuyerFormComponent } from './document-issue/components/buyer-form/buyer-form.component';
import { LineItemFormComponent } from './document-issue/components/line-item-form/line-item-form.component';
import { RadioButtonModule, AutoCompleteModule, CheckboxModule, CalendarModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { DocumentIssueFormService } from './document-issue/components/document-issue-form/document-issue-form.service';


@NgModule({
  imports: [
    CommonModule,
    DocumentRoutingModule,
    FileUploadModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    StepsModule,
    PdfViewerModule,
    NgbModule,
    ngfModule,
    CoreModule,
    TranslateModule,
    AutoCompleteModule,
    TableModule,
    CheckboxModule,
    CalendarModule,
    RadioButtonModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    DocumentUploadComponent,
    DocumentIssueComponent,
    DocumentIssueFormComponent,
    SellerFormComponent,
    DocumentFormComponent,
    BuyerFormComponent,
    LineItemFormComponent
  ],providers: [
    DocumentIssueFormService
  ]
})
export class DocumentModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document.module.ts